// extracted by mini-css-extract-plugin
export default {"srOnly":"JamSpinner_srOnly__x56yr","backdrop":"JamSpinner_backdrop__vtJRo"};